import React, { useState, useEffect, useCallback, memo } from "react";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";

import MenuItem from "@mui/material/MenuItem";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB } from "../../../api/Get_limited_Choose_Fields_From_MongoDB";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search";
import ViewECsForThisAgency from "./components/ViewECsForThisAgency";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

const ViewAgency = () => {
  const { id } = useParams();
  const { logout } = StaffuseAuth();

  //The below is the state for the form
  const [Agency, setAgency] = useState({
    _id: id,
    BasicInfo: {
      Name: "",
      Email: "",
      Phone: "",
      Website: "",
      //
      Country: "",
      City: "",
      Address: "",
      Address_Line_2: "",
      PostCode: "",
      //
      Type_of_Agency: "",
      Branches: "",
    },
    MetaData: {
      IP_id: "",
      Partnership_Agreement_Form_2025: "",
    },
    BankingInfo: {
      Bank_Name: "",
      Account_Name: "",
      VAT_Number: "",
      CRN: "",
      Tax_Code: "",
      Bank_Details: "",
      International_IBAN_BIC: "",
      UK_Sort_Code_Account: "",
      Commission_Payment_Communication_Email_Address: "",
    },
  });

  // let asdas = {
  //   BasicInfo: {
  //     Name: "Edulosophy International Ltd",
  //     Address: "124 City Road London EC1V 2NX ",
  //     Type_of_Agency: "Summer School;Academic Recruitment;Guardianship;",
  //     Phone: "07410638188",
  //     Website: "www.edulosophyuk.com",
  //     Branches: "N/A",
  //     Country: "China",
  //   },
  //   BankingInfo: {
  //     Bank_Name: "Metro Bank",
  //     Account_Name: "Edulosophy International Ltd",
  //     International_IBAN_BIC: "",
  //     UK_Sort_Code_Account: "23-05-80 / 27453031",
  //     Commission_Payment_Communication_Email_Address: "mayhuangxw@gmail.com",
  //   },
  //   MetaData: { IP_id: "65c38d6972976acb3923336d" },
  // };

  useEffect(() => {
    if (id !== "AddAgency") {
      Get_One_From_MongoDB("IP", "Agencies", id, setAgency, logout);
    }
  }, []);

  console.log(Agency);

  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB(
      "Staff",
      "Users",
      100,
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  //Filter the staff for IP's
  let IPStaff = Staff.filter((prop) =>
    prop.Team.toLowerCase().includes("ip".toLowerCase())
  );

  //This is the state for the update progress
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleAddAgency(e) {
    e.preventDefault();
    let data = Agency;
    delete data._id;
    Post_To_MongoDB(data, "IP", "Agencies", setIsSubmitting, logout);
  }

  function handleBasicUpdate(e) {
    e.preventDefault();
    let data = Agency;
    delete data._id;
    Update_To_MongoDB_By_ID(
      data,
      "IP",
      "Agencies",
      setIsSubmitting,
      id,
      logout
    );
  }

  function handleChange(e) {
    e.preventDefault();
    setAgency({ ...Agency, [e.target.name]: e.target.value });
  }

  //  Functions for handling changes in BasicInfo
  // const handleBasicInfoChange = (e) => {
  //   setAgency({
  //     ...Agency,
  //     BasicInfo: { ...Agency.BasicInfo, [e.target.name]: e.target.value },
  //   });
  // };

  const handleBasicInfoChange = useCallback((e) => {
    const { name, value } = e.target;
    setAgency((prevAgency) => ({
      ...prevAgency,
      BasicInfo: { ...prevAgency.BasicInfo, [name]: value },
    }));
  }, []);

  const handleBankingInfoChange = (e) => {
    setAgency({
      ...Agency,
      BankingInfo: { ...Agency.BankingInfo, [e.target.name]: e.target.value },
    });
  };

  // Functions for handling changes in BasicInfo and OrderInfo
  const handleMetaDataChange = (e) => {
    setAgency({
      ...Agency,
      MetaData: { ...Agency.MetaData, [e.target.name]: e.target.value },
    });
  };
  //---------------------------------Components---------------------------------
  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      }}
    >
      <h1 style={{ marginTop: "0px" }}>
        View Agency:{" "}
        {Agency.BasicInfo && Agency.BasicInfo.Name ? Agency.BasicInfo.Name : ""}
      </h1>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <section>
            <h2>Basic Info</h2>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  key="IP_id_1"
                  required
                  select
                  name="IP_id"
                  label="IP_id"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.MetaData && Agency.MetaData["IP_id"]
                      ? Agency.MetaData["IP_id"]
                      : ""
                  }
                  onChange={(e) => handleMetaDataChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <MenuItem value="" key={"null"}>
                    ---None---
                  </MenuItem>
                  {IPStaff.map((prop) => (
                    <MenuItem value={prop._id} key={prop._id}>
                      {prop.Username}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  key="IP_id_2"
                  name="IP_id"
                  label="IP_id"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  disabled
                  value={
                    Agency.MetaData && Agency.MetaData["IP_id"]
                      ? Agency.MetaData["IP_id"]
                      : ""
                  }
                  onChange={(e) => handleMetaDataChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Partnership_Agreement_Form_2025"
                  required
                  select
                  name="Partnership_Agreement_Form_2025"
                  label="Partnership_Agreement_Form_2025"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.MetaData &&
                    Agency.MetaData["Partnership_Agreement_Form_2025"]
                      ? Agency.MetaData["Partnership_Agreement_Form_2025"]
                      : ""
                  }
                  onChange={(e) => handleMetaDataChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <MenuItem value="">---None---</MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="_id"
                  name="_id"
                  label="_id"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={Agency["_id"]}
                  onChange={(e) => handleChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  disabled
                />
                <TextField
                  key="Name"
                  name="Name"
                  label="Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["Name"]
                      ? Agency.BasicInfo["Name"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />

                <TextField
                  key="Email"
                  name="Email"
                  label="Email"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["Email"]
                      ? Agency.BasicInfo["Email"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  key="Phone"
                  name="Phone"
                  label="Phone"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["Phone"]
                      ? Agency.BasicInfo["Phone"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Website"
                  name="Website"
                  label="Website"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["Website"]
                      ? Agency.BasicInfo["Website"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="Country"
                  name="Country"
                  label="Country"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["Country"]
                      ? Agency.BasicInfo["Country"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />

                <TextField
                  key="City"
                  name="City"
                  label="City"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["City"]
                      ? Agency.BasicInfo["City"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Address"
                  name="Address"
                  label="Address"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["Address"]
                      ? Agency.BasicInfo["Address"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Address_Line_2"
                  name="Address_Line_2"
                  label="Address_Line_2"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["Address_Line_2"]
                      ? Agency.BasicInfo["Address_Line_2"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="PostCode"
                  name="PostCode"
                  label="PostCode"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["PostCode"]
                      ? Agency.BasicInfo["PostCode"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="Type_of_Agency"
                  name="Type_of_Agency"
                  label="Type_of_Agency"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BasicInfo && Agency.BasicInfo["Type_of_Agency"]
                      ? Agency.BasicInfo["Type_of_Agency"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Branches"
                  name="Branches"
                  label="Branches"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  // value={
                  //   Agency.BasicInfo && Agency.BasicInfo["Branches"]
                  //     ? Agency.BasicInfo["Branches"]
                  //     : ""
                  // }
                  value={Agency.BasicInfo?.Branches || ""}
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  multiline
                  rows={11.45}
                />
              </Grid>
            </Grid>
          </section>
          <section>
            <h2>Banking Info</h2>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  key="Bank_Name"
                  name="Bank_Name"
                  label="Bank_Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo && Agency.BankingInfo["Bank_Name"]
                      ? Agency.BankingInfo["Bank_Name"]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Account_Name"
                  name="Account_Name"
                  label="Account_Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo && Agency.BankingInfo["Account_Name"]
                      ? Agency.BankingInfo["Account_Name"]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="VAT_Number"
                  name="VAT_Number"
                  label="VAT_Number"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo && Agency.BankingInfo["VAT_Number"]
                      ? Agency.BankingInfo["VAT_Number"]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="CRN"
                  name="CRN"
                  label="CRN"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo && Agency.BankingInfo["CRN"]
                      ? Agency.BankingInfo["CRN"]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Tax_Code"
                  name="Tax_Code"
                  label="Tax_Code"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo && Agency.BankingInfo["Tax_Code"]
                      ? Agency.BankingInfo["Tax_Code"]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Bank_Details"
                  name="Bank_Details"
                  label="Bank_Details"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo && Agency.BankingInfo["Bank_Details"]
                      ? Agency.BankingInfo["Bank_Details"]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                {" "}
                <TextField
                  key="International_IBAN_BIC"
                  name="International_IBAN_BIC"
                  label="International_IBAN_BIC"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo &&
                    Agency.BankingInfo["International_IBAN_BIC"]
                      ? Agency.BankingInfo["International_IBAN_BIC"]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="UK_Sort_Code_Account"
                  name="UK_Sort_Code_Account"
                  label="UK_Sort_Code_Account"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo &&
                    Agency.BankingInfo["UK_Sort_Code_Account"]
                      ? Agency.BankingInfo["UK_Sort_Code_Account"]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Commission_Payment_Communication_Email_Address"
                  name="Commission_Payment_Communication_Email_Address"
                  label="Commission_Payment_Communication_Email_Address"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    Agency.BankingInfo &&
                    Agency.BankingInfo[
                      "Commission_Payment_Communication_Email_Address"
                    ]
                      ? Agency.BankingInfo[
                          "Commission_Payment_Communication_Email_Address"
                        ]
                      : ""
                  }
                  onChange={(e) => handleBankingInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
          </section>
        </Grid>
      </Grid>
      <ViewECsForThisAgency id={id} />
      <h1>Actions</h1>
      <Button
        type="submit"
        variant="contained"
        sx={{ mt: 3, ml: 1, backgroundColor: !Agency.MetaData?.IP_id || Agency.MetaData?.IP_id === "" ? "grey" : "" }}
        disabled={isSubmitting || (!Agency.MetaData?.IP_id || Agency.MetaData?.IP_id === "")}
        onClick={(e) =>
          id === "AddAgency" ? handleAddAgency(e) : handleBasicUpdate(e)
        }
      >
        {isSubmitting
          ? "Submitting..."
          : id === "AddAgency"
          ? "Add Agency"
          : "Update Agency"}
      </Button>
    </div>
  );
};

export default ViewAgency;
